/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ModalErrorIcon - Auto-generated from icon.js
 */
export const ModalErrorIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_4263_12323)">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.5 0C7.6625 0 0.5 7.1625 0.5 16C0.5 24.8375 7.6625 32 16.5 32C25.3375 32 32.5 24.8375 32.5 16C32.5 7.1625 25.3375 0 16.5 0ZM24.0312 21.9781C24.4249 22.3656 24.4312 22.9969 24.0468 23.3937C23.6593 23.7875 23.028 23.7937 22.6312 23.4094L16.4999 17.4L10.3687 23.4062C9.97493 23.7937 9.34055 23.7875 8.95305 23.3906C8.56555 22.9969 8.5718 22.3625 8.96868 21.975L15.0718 16L8.96868 10.0219C8.57493 9.63438 8.56868 9.00313 8.95305 8.60625C9.34055 8.2125 9.9718 8.20625 10.3687 8.59063L16.4999 14.6L22.6312 8.59375C23.0249 8.20625 23.6593 8.2125 24.0468 8.60938C24.4343 9.00313 24.428 9.6375 24.0312 10.025L17.928 16L24.0312 21.9781Z" fill="#D0021B" />
		</g>
		<defs>
			<clipPath id="clip0_4263_12323">
				<rect width="32" height="32" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export default ModalErrorIcon;
